import type { MagentoApiGetCustomerCartIdQueryResponse } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export const getCustomerCartIdEndpoint = (builder: MagentoApiBuilder) => ({
  getCustomerCartId: builder.query<MagentoApiGetCustomerCartIdQueryResponse, void>({
    query: () => ({
      method: "getCustomerCartId",
      params: [],
    }),
    providesTags: [TAGS.CART_ID],
  }),
});
